import React, { useEffect, useState } from 'react';
import Modal from "react-modal";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Container, Table, Button, Card, CardHeader, CardBody, Spinner } from 'reactstrap';
import { getCustomStyles } from "../share/ModalStyle";
import { CgClose } from "react-icons/cg";
import Swal from "sweetalert2";
import '../share/form.css';
import './ConsiderProfile.css';
import { FaUserCheck, FaTimesCircle } from "react-icons/fa";

export function ConsiderProfileDetailComponent() {
    const user = JSON.parse(localStorage.getItem("userData"))
    const myCustomStyles = getCustomStyles();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const profileLogId = searchParams.get("req");

    const [logData, setLogData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        async function getListDataUserChangeProfile() {
            setLoading(true);
            // let postData = new FormData();
            // postData.append("deptId", user.deptId);
            try {
                const res = await fetch(`/api/Profile/profile-log/detail-view/${profileLogId}`, {
                    method: "GET",
                    headers: { 'token': user.token },
                })
                let resJson = await res.json()
                setLogData(resJson.dataenum);
            } catch (err) {
                // console.log(err);
            } finally {
                setLoading(false);
            }
        }
        getListDataUserChangeProfile();

    }, [profileLogId]);


    const handleApprove = async () => {
        Swal.fire({
            title: "ยืนยันอนุมัติ?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "อนุมัติ",
            cancelButtonText: "ยกเลิก"
        }).then(async (result) => {
            if (result.isConfirmed && profileLogId) {
                try {
                    let postData = new FormData();
                    postData.append("profileLogId", profileLogId);
                    postData.append("flagStatus", "Y");
                    postData.append("userApprove", user.fullName)
                    const res = await fetch("/api/Profile/approveChangeLog", {
                        method: "POST",
                        headers: { 'token': user.token },
                        body: postData
                    })

                    const resJson = await res.json();

                    if (resJson.status === 1) {
                        Swal.fire({
                            icon: "success",
                            title: "อนุมัติสำเร็จ",
                            // text: "",
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.location.reload()
                            }
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "อนุมัติไม่สำเร็จ",
                            text: `เนื่องจาก ${resJson.message}`,
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        });
                    }
                } catch (err) {

                }
            }
        })

        // .then((result) => {
        // if (result.isConfirmed && profileLogId) {
        //     fetch(`/api/approve-profile-log/${profileLogId}`)
        //         .then(() => {
        //             Swal.fire("สำเร็จ", "อนุมัติการเปลี่ยนแปลงแล้ว", "success");
        //             navigate("/admin/profile-review"); // กลับไปหน้ารายการ
        //         })
        //         .catch(() => {
        //             Swal.fire("ผิดพลาด", "ไม่สามารถอนุมัติได้", "error");
        //         });
        // }
        // });
    };


    const handleReject = async () => {
        Swal.fire({
            title: "ยืนยันการปฎิเสธหรือไม่ ?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "อนุมัติ",
            cancelButtonText: "ยกเลิก"
        }).then(async (result) => {
            if (result.isConfirmed && profileLogId) {
                try {
                    let postData = new FormData();
                    postData.append("profileLogId", profileLogId);
                    postData.append("flagStatus", "N");
                    postData.append("userApprove", user.fullName)
                    const res = await fetch("/api/Profile/approveChangeLog", {
                        method: "POST",
                        headers: { 'token': user.token },
                        body: postData
                    })

                    const resJson = await res.json();

                    if (resJson.status === 1) {
                        Swal.fire({
                            icon: "success",
                            title: "ปฎิเสธสำเร็จ",
                            // text: "",
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.location.reload()
                            }
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "ปฎิเสธไม่สำเร็จ",
                            text: `เนื่องจาก ${resJson.message}`,
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        });
                    }
                } catch (err) {

                }
            }
        })

        // .then((result) => {
        // if (result.isConfirmed && profileLogId) {
        //     fetch(`/api/approve-profile-log/${profileLogId}`)
        //         .then(() => {
        //             Swal.fire("สำเร็จ", "อนุมัติการเปลี่ยนแปลงแล้ว", "success");
        //             navigate("/admin/profile-review"); // กลับไปหน้ารายการ
        //         })
        //         .catch(() => {
        //             Swal.fire("ผิดพลาด", "ไม่สามารถอนุมัติได้", "error");
        //         });
        // }
        // });
    };
    // const handleReject = () => {
    //     Swal.fire("ยังไม่รองรับ", "ระบบปฏิเสธยังไม่ถูกพัฒนา", "info");
    // };

    if (loading) {
        return <Container className="text-center mt-5"><Spinner color="primary" /></Container>;
    }

    if (!logData) {
        return <Container className="text-center mt-5">ไม่พบข้อมูลคำร้อง</Container>;
    }

    return (
        <Container className="mb-5 mt-4">

            <Card className="card-modern mb-4">
                <CardHeader className="bg-light fw-bold fs-6">ข้อมูลคำขอ</CardHeader>
                <CardBody>
                    {/* <p><strong>รหัสคำขอ:</strong> {logData.profileLogId}</p> */}
                    <p><strong>รหัสอ้างอิง:</strong> {logData.registerId}</p>
                    {/* <p><strong>ผู้ร้องขอ:</strong> {logData.requestedBy}</p> */}
                    {/* <p><strong>วันที่ร้องขอ:</strong> {new Date(logData.requestDate).toLocaleString()}</p> */}
                    {logData.pathFile && (
                        <p><strong>ไฟล์แนบ:</strong> <a href={logData.pathFile} target="_blank" rel="noreferrer" className="text-decoration-underline">📎 เปิดเอกสาร</a></p>
                    )}
                </CardBody>
            </Card>

            {logData.fieldGroups.map((group, idx) => (
                <Card key={idx} className="card-modern mb-4">
                    <CardHeader className="bg-light fw-bold fs-6">
                        {group.targetTable === 'TdRegisters'
                            ? 'ข้อมูลลงทะเบียน'
                            : group.targetTable === 'TdAddresses'
                                ? 'ข้อมูลที่อยู่'
                                : group.targetTable === 'TdRegisterDetails'
                                    ? 'ประเภทผู้ใช้งาน'
                                    : 'ข้อมูลผู้มีอำนาจ'}
                        {group.personName && <> - <span className="text-muted">{group.personName}</span></>}
                    </CardHeader>
                    <CardBody>
                        <div className="table-responsive">
                            <Table bordered className="table-modern align-middle">
                                <thead>
                                    <tr>
                                        <th>ชื่อฟิลด์</th>
                                        <th>ข้อมูลเดิม</th>
                                        <th>ข้อมูลใหม่</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {group.fields.map((field, i) => (
                                        <tr key={i}>
                                            <td className="text-secondary">{field.columnLabel}</td>
                                            <td>{field.oldValue || '-'}</td>
                                            <td className={field.oldValue !== field.newValue ? "text-success fw-semibold" : "text-muted"}>
                                                {field.newValue || '-'}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </CardBody>
                </Card>
            ))}

            {logData.flagStatus === "W" ? (
                <div className="text-center mt-4 d-flex justify-content-center gap-3 flex-wrap">
                    <button className="btn btn-modern btn-success d-flex align-items-center gap-2" onClick={handleApprove}>
                        <FaUserCheck /> อนุมัติ
                    </button>
                    <button className="btn btn-modern btn-danger d-flex align-items-center gap-2" onClick={handleReject}>
                        <FaTimesCircle /> ปฏิเสธ
                    </button>
                </div>
            ) : (
                <div className="text-center mt-4">
                    <span className={`badge fs-6 ${logData.flagStatus === "Y" ? "bg-success" : "bg-danger"}`}>
                        {logData.flagStatus === "Y" ? "คำขอนี้ได้รับการอนุมัติแล้ว" : "คำขอนี้ถูกปฏิเสธแล้ว"}
                    </span>
                </div>
            )}
        </Container>
    );
}
